const base = {
    get() {
        return {
            url: "http://hycm.baibaiyeye.com.cn/ssm48yhg/",
            name: "ssm48yhg",
            // 退出到首页链接
            indexUrl: 'http://hycm.baibaiyeye.com.cn/ssm48yhg/front/h5/index.html'
        };
    },
    getProjectName() {
        return {
            projectName: "合意传媒"
        }
    }
}
export default base
